'use client';

import { Palette, Layers } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { SectionList } from './SectionList';
import { SettingsEditor } from './SettingsEditor';
import { TemplateSwitcher } from './TemplateSwitcher';

interface BuilderSidebarProps {
  activeTab?: string;
  onTabChange?: (tab: string) => void;
}

export function BuilderSidebar({ activeTab, onTabChange }: BuilderSidebarProps) {
  return (
    <div className="h-full flex flex-col bg-background border-r overflow-hidden">
      <TemplateSwitcher />
      <Tabs value={activeTab} onValueChange={onTabChange} defaultValue="content" className="flex-1 flex flex-col min-h-0 overflow-hidden">
        {/* Desktop-only tab list — on mobile this is in the sub-header */}
        <TabsList className="builder-sidebar-tabs grid w-full grid-cols-2 rounded-none border-b bg-muted/50 shrink-0 h-12 sticky top-0 z-10 touch-none p-0">
          <TabsTrigger 
            value="content" 
            className="gap-2 rounded-none h-full text-muted-foreground data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-none"
          >
            <Layers className="h-4 w-4" />
            <span>Content</span>
          </TabsTrigger>
          <TabsTrigger 
            value="design" 
            className="gap-2 rounded-none h-full text-muted-foreground data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-none"
          >
            <Palette className="h-4 w-4" />
            <span>Design</span>
          </TabsTrigger>
        </TabsList>

        <div className="flex-1 overflow-hidden">
          <TabsContent value="content" className="m-0 h-full overflow-y-auto overscroll-contain touch-pan-y">
            <div className="p-4 pb-32">
              <SectionList />
            </div>
          </TabsContent>

          <TabsContent value="design" className="m-0 h-full overflow-y-auto overscroll-contain touch-pan-y">
            <div className="p-4 pb-32">
              <SettingsEditor />
            </div>
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
}

